import mitt from "mitt";

type ApplicationEvents = {
  // notifications
  notification_created: any;

  /*
   * Support, pushed to us by the billing app.
   *
   * These conversations live over there and it has no socket to this browser,
   * so it tells our own backend and that puts it on the notifications channel
   * we are already subscribed to. Before this the widget asked every few
   * seconds whether anything had changed.
   */
  support_message_received: any;
  support_message_changed: any;
  support_conversation_read: any;
  support_updates_changed: any;

  // call-center
  progress: any;
  accepted: any;
  completed: any;
  confirmed: any;
  incoming: any;
  outgoing: any;

  // call-center
  uh_call_created: any;
  uh_calls_handled: any;
  call_created: any;
  call_updated: any;

  // help-desk
  ticket_assigned: any;
  ticket_created: any;
  ticket_unpicked: any;
  ticket_updated: any;
  conv_created: any;
  conv_updated: any;
  ticket_convs_read: any;
  meta_user_updated: any;

  // shortcuts
  call: any;
  reject: any;
  accept: any;
  hold: any;
  add_task: any;
  add_note: any;

  // tasks
  task_created: any;
  task_reminder: any;
  task_overdue: any;

  // crm
  follow_up_assigned: any;
  follow_up_removed: any;

  // settings
  audio_settings_changed: any;
};

export default defineNuxtPlugin(() => {
  // Then we just inform mitt about our event types
  const emitter = mitt<ApplicationEvents>();

  return {
    provide: {
      event: emitter.emit, // Will emit an event
      listen: emitter.on, // Will register a listener for an event
      unListen: emitter.off,
    },
  };
});
